const CouponAgreementEnglish = () => {
  return (
    <>
      <div className="leading-5">
        1. Eligibility and Process
      </div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
        (1) “Guest Coupon” (hereinafter referred to as the “Coupon”) is issued when Hankyu Hanshin Department Store Inc. 
        (hereinafter referred to as the “Company”) confirms that the tax-exempt status of the User by reviewing user’s passport 
        after the User agrees on this Guest Coupon Terms and Conditions for Use (hereinafter referred to as the “Terms”) and applies to use the Coupon.
        <br /> (2) The tax-exempt status of the user may be checked upon the use of the Coupon. 
      </div>
      <div className="mt-4 whitespace-nowrap leading-[150%]">
        2. Issuance and Use of Coupon
      </div>

      <div className="self-start mt-2 ml-4 text-xs font-light">
        (1) Only one Coupon per one user is issued and the User may use the Coupon at Hankyu Department Store Umeda Main Store, 
        Hanshin Department Store Umeda Main Store, Kobe Hankyu, Hankyu Men’s Osaka, Hankyu Men’s Tokyo, and Hakata Hankyu.
        <br />
        (2) The Coupon may be used only by the User who has signed or registered his/her information and may not be transferred or leased to any other person. 
        When it is found that the Coupon has been transferred or leased to someone else, the Coupon may be disabled and the re-application may not be accepted. 
        <br />
        (3) As a rule, the Coupon is issued digitally. 
      </div>
      <div className="mt-4 leading-[150%]">3. Term</div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
        The Coupon is effective for 7 days including and from the date of issuance. 
      </div>
      <div className="mt-4 leading-[150%]">4. Privileges</div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
        (1) The Coupon must be presented prior to the payment. <br />
        (2) Without presenting the Coupon, no privilege is applicable. <br />
        (3) Users agree that none of privilege is available by the presentation of the receipt of the payment.  <br />
        (4) The privileges of the Coupon may not be used along with other privileges, 
        such as point card, privileges, benefits, etc. The Coupon may not be used in some areas. 
        The Coupon may not be used for an item with the price of less than 1,000 yen (excluding tax), bargain items, gift bags “Fuku-bukuro”, groceries, restaurants/cafés, and some sales areas.   <br />
        (5) Privileges are subject to addition, change, or termination without prior notice.
      </div>
      <div className="mt-4 leading-[150%]">5. Return of Purchased Item</div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
        The presentation of the Coupon is requested upon the return of the purchased item by using the Coupon.
      </div>
      <div className="mt-4 leading-[150%]">6. Reissuance</div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
        (1) The User is requested to bring his/her passport to apply for the reissuance of the Coupon. 
        <br />
        (2) The previous Coupon is terminated automatically upon the reissuance of the new Coupon. 
      </div>
      <div className="mt-4 leading-[150%]">7. Termination of Membership</div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
        The User loses his/her membership when he/she violated one or multiple of these Terms, such as the transfer or the lease of the Coupon ,or with any dishonest act. 
      </div>
      <div className="mt-4 leading-5">8. Addition and Modification of Terms</div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
        Changes to these Terms will be announced on the website, the store signage, or other methods by disclosing the date and the description of the change in advance, 
        then it is applicable on the date of the change if the change satisfies following conditions.
        <br />
        (1) The change conforms to Users’ interest in general.  <br />
        (2) The change complies with the purpose of this agreement and is reasonable in terms of the necessity of the change and the appropriateness of the contents after the change.
      </div>
      <div className="mt-4 leading-[150%]">9. End of Coupon Service</div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
        The Coupon Service may be ended by the Company at its discretion. In that case, the date of the termination shall be publicly announced on its website and/or its store signage or other methods.
        Users of the Coupon shall acknowledge and understand that the privilege of the Coupon is no longer available after that date.
      </div>
      <div className="mt-4 leading-[150%]">10. Management and Collection of Personal Information</div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
        The Company will collect the following information (hereinafter referred to as the “Personal Information”) to operate and manage the Coupon:
        <br />
        (1) User’s information (Name, Date of Birth, Nationality, Address, Telephone Number, E-mail Address)  <br />
        (2) Information on the use of the Coupon (name of the shop used, items, total amount of use, number of uses, etc.)
      </div>
      <div className="mt-4 leading-5">
         11. Purpose of Use of Personal Information 
      </div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
        The Company will hold the Personal Information of the User collected by the Company in accordance with Article 10 for the following purposes, 
        after taking measures to protect the Personal Information:
        <br />
        (1) To provide Users with information on the operation of the Coupon and special offers to Users  <br />
        (2) To provide information on the Company’s events, products, services, and information <br />
        (3) To perform marketing activities, product development, and renewal  <br />
        (4) To contact a User to confirm the details of his/her use of the Coupon
      </div>
      <div className="mt-4 leading-[150%]">12. Provision of Personal Information to H2O Group Companies</div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
        The Company will share with each H2O Group Company* the Personal Information of the User collected 
        by the Company in accordance with Article 10 for the following purposes:
        <br />
        (1) To provide information on the events, products, services, and information of each H2O Group Company  <br />
        (2) To perform marketing activities, product development, and renewal
        <br />
        * “H2O Group Company” means H2O Retailing Corporation or any of the companies listed at https://www.h2o-retailing.co.jp/ja/company/group.html.
        The Company (https://www.hankyu-hanshin-dept.co.jp/profile.html) is responsible for the control of personal data shared.
      </div>
      <div className="mt-4 leading-[150%]">
        13. User’s Exercise of the Right to Request Disclosure, Correction, Deletion, 
        or Discontinued Use or Provision of Personal Information
      </div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
         If a User exercises his/her right to request the disclosure, correction, deletion, 
        or discontinued use or provision of his/her Personal Information to the extent permitted 
        by applicable laws and regulations for legitimate reasons through the procedures prescribed by the Company, 
        the Company will, in principle, accept the request. However, even in such a case, the Company may, 
        to the extent permitted by applicable laws and regulations, continue to use, provide, 
        and otherwise process the Personal Information within the scope of purposes necessary for the operation and management of the Coupon, 
        such as administration of the Coupon and response to inquiries. 
      </div>
      <div className="mt-4 leading-5">
        14. Method of Requesting Disclosure, Correction, Deletion, or Discontinued Use or Provision of Personal Information
      </div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
        To request disclosure or other processing of the Personal Information, 
        a User shall fill in the required information on a notification form provided by the Company 
        and submit it to the Company together with a passport or other document that proves the identity of the User. 
        Users acknowledge and understand that it may take a considerable amount of time from the submission of the notification form to the disclosure or other processing of information. 
        In addition, a predetermined fee may be requested to pay in advance for such requests to the extent permitted by applicable laws and regulations.
      </div>
      <div className="mt-4 leading-5">
        15. Non-acceptance of Use of Personal Information
      </div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
        (1) The User’s provision of his/her Personal Information constitutes a necessary requirement for the operation and management of the Coupon 
        and for the performance of this agreement. In order to use the Coupon, the User is required to consent to these Terms and provide the Personal Information specified in Article 10. 
        <br />
        (2) The User is not obliged to provide his/her Personal Information. 
        However, if the User does not consent to these Terms or refuses to provide the Personal Information necessary for the operation and management of the Coupon, 
        the Company may decline to issue the Coupon. 
      </div>
      <div className="mt-4 leading-[150%]">16. Retention Period of Personal Information </div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
        (1) The Company will set a minimum retention period for Personal Information collected, 
        in light of the purposes of processing, and retain the Personal Information only for the duration of that period. 
        In determining the retention period, the Company will take into account its obligations under applicable laws and regulations 
        and the period necessary for the performance of this agreement. 
        <br />
        (2) Personal Information that no longer needs to be retained will be promptly destroyed or otherwise disposed of by appropriate methods. 
      </div>
      <div className="mt-4 leading-5">
        17. Personal Information Controller and Point of Contact
      </div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
        The name of the entity of the controller for Personal Information collected in the operation and management of the Coupon and its point of contact are as follows:
        Controller: Hankyu Hanshin Department Store Inc.
        <br />
        Point of contact: Please see Article 19 “Inquiries”
      </div>
      <div className="mt-4 leading-5">
        18. Special Provisions Regarding Personal Data of Users Residing in the EEA or the United Kingdom
      </div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
      1. The Company will process the User’s personal data on the following legal bases: 
      </div>
      <div className="self-start mt-2 ml-8 text-xs font-light">
        (1) To provide information on the operation of the Coupon and special offers to Users (the performance of a contract) <br />
        (2) To provide information on the Company’s events, products, services, and information (legitimate interests) <br />
        (3) To perform marketing activities, product development, and renewal (legitimate interests)  <br />
        (4) To contact a User to confirm the details of his/her use of the Coupon (the performance of a contract)  <br />
        (5) To comply with applicable laws and regulations, court orders, and legal proceedings or to establish, exercise, or defend the Company’s legal claims (legitimate interests)
      </div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
      2. The User has the following rights with respect to his/her personal data. 
        The User may exercise the rights by contacting the Company’s point of contact provided in Article 19. 
        The User may also lodge a complaint with the competent data protection supervisory authority if he/she believes that any of his/her rights have been infringed: 
      </div>
      <div className="self-start mt-2 ml-8 text-xs font-light">
        (1) The right to obtain information about the processing of the personal data and the right to access the personal data held by the Company <br />
        (2) The right to request from the Company correction of the personal data if it is inaccurate or incomplete <br />
        (3) The right to request from the Company erasure of the personal data in certain circumstances  <br />
        (4) The right to request from the Company restriction of processing of the personal data in certain circumstances  <br />
        (5) The right to raise an objection to the processing of the personal data with the Company  <br />
        (6) The right to receive the personal data in a structured, commonly used, and machine-readable format, 
        and/or to request that the Company transmit the personal data directly to another controller if technically feasible <br />
        (7) The right to, at any time, withdraw any consent given to the processing of the personal data 
        (without affecting the lawfulness of the processing based on the consent before its withdrawal)
      </div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
      3. The User’s personal data may be transferred to third parties outside the EEA or the United Kingdom. 
        If the Company transfers the personal data to such a third party, it will ensure that either of the following safeguards is in place. 
        The User may obtain further details of the protection afforded to the personal data in case of such transfer by contacting the Company’s point of contact provided in Article 19. 
      </div>
      <div className="self-start mt-2 ml-8 text-xs font-light">
        (1) The country or territory where the entity to which User’s personal data is transferred is located has been designated 
        by the European Commission or the UK Government as ensuring an adequate level of protection for the User’s rights and freedoms concerning the personal data. <br />
        (2) The third party has concluded with the Company the standard data protection clauses adopted by the European Commission or the UK Government.
      </div>
      <div className="mt-4 leading-[150%]">19. Inquiries</div>
      <div className="self-start mt-2 ml-4 text-xs font-light">
        Users may use the following contact information for inquiries, notifications, and other communications regarding the Coupon.
        <br />Hankyu Hanshin Department Store, Oversea Customer Counter
        <br />
        {"https://service.hankyu-hanshin-dept.co.jp/inquiry_en"}
        <br />
        Telephone: 0081-6-6361-1381
        <br />
        Business Hours from 10:00 am to 6:00 pm (Japan Time)
        <br />
         ※ 1. Please read and agree to these Terms before making application.
        <br />
         ※ 2. These Terms shall be governed by and construed in accordance with the laws of Japan. 
        Terms written in a language other than Japanese is provided as the translation only.
      </div>
    </>
  );
};

export default CouponAgreementEnglish;
